
class PaymentVoucherApi {

    updateState(data) {
        const url = apiUrl + `paymentvouchers/state/${data.id}`;
        return api.call('put', url, data)
          .then(({ data }) => data);
    }

    getNextNumber() {
        var url = apiUrl + 'paymentvouchers/generateVoucherNumber';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getPaymentVoucherStatus() {
        var url = apiUrl + 'paymentvouchers/states';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getListByCurrentBusiness()
    {
        var url = apiUrl + 'paymentvouchers/currentBusiness/';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });

    }

    getList() {
        var url = apiUrl + 'paymentvouchers';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'paymentvouchers/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        var url = apiUrl + 'paymentvouchers';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }

    update(data) {
        var url = apiUrl + 'paymentvouchers/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    delete(id) {
        var url = apiUrl + 'paymentvouchers/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

    approve(id) {
        var url = apiUrl + 'paymentvouchers/approve/';
        return api.call('put', url + id)
            .then(({ data }) => {
                return data
            });
    }

    reject(id) {
        var url = apiUrl + 'paymentvouchers/reject/';
        return api.call('put', url + id)
            .then(({ data }) => {
                return data
            });
    }

    markAsPaid(id) {
        var url = apiUrl + 'paymentvouchers/markpaid/';
        return api.call('put', url + id)
            .then(({ data }) => {
                return data
            });
    }

    voidVoucher(id) {
        var url = apiUrl + 'paymentvouchers/void/';
        return api.call('put', url + id)
            .then(({ data }) => {
                return data
            });
    }

    getUnpaidBills(vendorId = null) {
        var url = apiUrl + 'paymentvouchers/unpaidBills';
        if (vendorId) {
            url += '?vendorId=' + vendorId;
        }
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getUnpaidExpenses(vendorId = null) {
        var url = apiUrl + 'paymentvouchers/unpaidExpenses';
        if (vendorId) {
            url += '?vendorId=' + vendorId;
        }
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    removePaymentProof(voucherId, documentId) {
        var url = apiUrl + `paymentvouchers/RemovePaymentProof/${voucherId}/${documentId}`;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

    removeSupportingDocs(voucherId, documentId) {
        var url = apiUrl + `paymentvouchers/RemoveSupportingDocs/${voucherId}/${documentId}`;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }
}

const paymentVoucherApi = new PaymentVoucherApi();
export default paymentVoucherApi;
